import { Component, OnDestroy } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { SharedService } from 'src/app/modules/gasprecio/services/shared.service';

@Component({
  selector: 'app-select-variable-cross-report',
  templateUrl: './select-variable-cross-report.component.html',
  styleUrls: ['./select-variable-cross-report.component.scss']
})
export class SelectVariableCrossReportComponent implements OnDestroy {

  public items: any[] = [
    { value: 'sales', variable: 'sales', name: 'Ventas Litros' },
    { value: 'PDM', variable: 'pdm', name: 'PDM Litros' },
    { value: 'sales_value', variable: 'sales', name: 'Ventas Valor (mill)' },
    { value: 'PDM_value', variable: 'pdm', name: 'PDM Valor' }
  ];
  public variableSelected: any = [];
  public ngxDisabled = true;
  rol;
  variableSelected$: Subscription;

  constructor(
    public sanitizer: DomSanitizer,
    private sharedService: SharedService
  ) {
    this.rol = localStorage.getItem('rol');
    this.variableSelected$ = sharedService.sharedVariableCrossReport.subscribe((variableSelected: string) => {
      if (this.variableSelected !== variableSelected) {
        this.variableSelected = variableSelected;
      }
    });
  }

  public style(data: string): SafeStyle {
    return this.sanitizer.bypassSecurityTrustStyle(data);
  }

  ngOnDestroy() {
    this.variableSelected$.unsubscribe();
  }

  changeVariable(event: any) {
    this.variableSelected = event;
    this.sharedService.nextVariableCrossReport = this.variableSelected;
  }

}
